import { boolean, object, string } from 'yup';
import { CommonValidationTranslations } from '@/core/utils/commonValidationTranslations';

export const emailLoginSchema = object().shape({
  terms: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
  privacy: boolean()
    .required(() => CommonValidationTranslations.requiredField())
    .oneOf([true], () => CommonValidationTranslations.requiredField()),
  email: string()
    .email()
    .required(() => CommonValidationTranslations.requiredField()),
});
